import { useState } from "react";
import { CheckSelect } from "vagaro-website-rendering/src/components/CustomMultiSelect";
import { DownCaret } from "vagaro-website-rendering/src/components/Icons/Carets";

export function FilterDropDown({label,displayValue,updated,startExpanded,children}:{label:string,displayValue:string,updated:boolean,startExpanded?:boolean,children?:any}){

    const [isExpanded,setIsExpanded] = useState(startExpanded??false);

    return <><div className="flex-row justify-between w-full " style={{fontSize:"14px",cursor:"pointer"}}
             onClick={()=>{setIsExpanded(!isExpanded)}}
            > 
            <label className={updated?"updated":"not-updated"}>{label}</label>

            <div className="flex-row gap-med">
                <div className="ellipsis" style={{maxWidth:"100px"}} >{displayValue}</div>
                <div style={{fontSize:"10px",transform:(!isExpanded?"rotateZ(-90deg)":""),transition:".2s"}}>
                    <DownCaret/>
                </div>
            </div>
            </div>
            {
                isExpanded&&<>{children}</>
            }
            </>


}

export function MapFilterOptions({allOptions,selectedOptions,updateSelected,wording}:{wording?:string,allOptions:{name:string,id:string}[],selectedOptions:string[],updateSelected:(newOptions:string[])=>void}){
 return <><div style={{fontSize:"14px",marginTop:"4px",background:"white",borderRadius:"4px",overflow:"hidden"}} >
    <div className="flex-row justify-between" style={{background:"#f2f2f2"}}>
        <button className=" invisible-button" style={{padding:"6px 12px"}} onClick={()=>updateSelected([...allOptions.map((n)=>n.id)])} >Select All</button>
        <button  className=" invisible-button" style={{padding:"6px 12px"}} onClick={()=>updateSelected([])}>Clear All</button>
    </div>
    
    {allOptions.map((option,index)=>{
   return  <FilterCheckbox key={index} label={option.name} isChecked={selectedOptions.includes(option.id)} onChange={(on)=>{
        if(on){
            updateSelected([...selectedOptions,option.id]);
        }
        else{
            updateSelected(selectedOptions.filter((v)=>v!=option.id));
        }
    }}/>

 })}
 {allOptions.length==0&&<div style={{padding:"8px 8px 8px 16px",fontWeight:"500"}}>{`No ${wording??"Options"} Available`}</div>}
 
 </div></>

 

}


export function FilterCheckbox({label,isChecked,onChange,nested}:{label:string,isChecked:boolean,onChange?:(on:boolean)=>void,nested?:boolean}){
    return <div className="flex-row align-start" style={{padding:(nested?"8px 8px 8px 32px":"8px"),cursor:"pointer"}}onClick={()=>onChange&&onChange(!isChecked)}>   
                <div style={{paddingTop:".2em"}}><CheckSelect isChecked={isChecked}/></div> 
                <span  style={{marginLeft:"8px"}} className="w-full">{label}</span>
            </div>
}
